import React from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from '../http/http';
import axios from 'axios';

const RedirectButton = () => {

  const redirectURL = localStorage.getItem("redirectUrl");
  const navigate = useNavigate();

  const token = localStorage.getItem('token');
  const deviceId = localStorage.getItem('deviceId');

  const handleClick = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/check-session`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Device-Id": deviceId,
            "User-Agent": navigator.userAgent
          }
        }
      );

      // ✅ If 200 → redirect
      if (response.status === 200) {
        if (redirectURL) {
          window.location.href = redirectURL;
        } else {
          // console.log("No redirect URL found");
        }
      }

    } catch (error) {

      // ❌ If 401 → clear cookies + login
      if (error.response?.status === 401) {

   localStorage.removeItem('msisdn');
localStorage.removeItem('redirectUrl');
localStorage.removeItem('currency');
localStorage.removeItem('token');
localStorage.removeItem('deviceId');

        navigate('/login');
      } else {
        // console.error("Something went wrong");
      }
    }
  };

  return (
    <button
      className="w-full py-4 bg-[#00D9FF] text-black border-none rounded-lg text-base font-semibold cursor-pointer"
      onClick={handleClick}
    >
      Start Yo XR Journey
    </button>
  );
};

export default RedirectButton;